import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {BehaviorSubject, Subject} from "rxjs";
import {filter, finalize, map, takeUntil, withLatestFrom} from "rxjs/operators"
import {Dialog} from "@angular/cdk-experimental/dialog";
import {DisclaimerComponent} from "../components/disclaimer.component";

interface FormData {
    email: string
}
@Component({
    selector: "app-reset",
    templateUrl: "./reset-request.component.html",
    styleUrls: ["./reset-request.component.scss"]
})
export class ResetRequestComponent implements OnInit, OnDestroy {

    public readonly submitSuccess$ = new BehaviorSubject(false)
    public readonly submitting$ = new BehaviorSubject<boolean>(false)
    public readonly submitError$ = new BehaviorSubject<string | null>(null)

    private readonly reset$ = new Subject<boolean>()
    private readonly destroyed$ = new Subject<boolean>()

    public readonly email = new FormControl(null, [Validators.email, Validators.required])
    public readonly form = new FormGroup({email: this.email})

    constructor(private readonly http: HttpClient,
                private readonly dialog: Dialog) {
    }

    public ngOnInit() {
        this.reset$
            .pipe(takeUntil(this.destroyed$))
            .pipe(withLatestFrom(this.form.statusChanges))
            .pipe(map(([_, status]) => status))
            .pipe(filter((status) => status === "VALID"))
            .pipe(withLatestFrom(this.form.valueChanges))
            .pipe(map(([_, formData]) => formData))
            .subscribe((formData) => this.sendResetRequest(formData))

    }

    public reset() {
        this.reset$.next(true)
    }

    private sendResetRequest(formData: FormData) {

        const userData = {
            ...formData,
            broker: "FUTURE_ASSIST"
        }

        this.submitting$.next(true)
        this.submitError$.next(null)

        this.http
            .post("/tradefloor/public_api/forgot", userData)
            .pipe(takeUntil(this.destroyed$))
            .pipe(finalize(() => this.submitting$.next(false)))
            .subscribe(() => this.submitSuccess$.next(true),
                (errorResponse) => this.resetError(errorResponse))
    }

    private resetError(errorResponse: HttpErrorResponse) {
        this.submitError$.next(this.extractErrorMessage(errorResponse))
    }

    private extractErrorMessage(errorResponse: HttpErrorResponse) {
        switch (errorResponse.status) {
            case 503:
                return "We are performing maintenance. Please try again later."
            default:
                return "There was an error processing your request"
        }
    }

    public showTerms() {
        this.dialog.openFromComponent(DisclaimerComponent)
    }

    public ngOnDestroy(): void {
        this.destroyed$.next(true)
        this.destroyed$.complete()
    }
}
